import * as React from 'react';
import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { space } from 'styled-system';
/**
 * @param {string} color
 * Component generated with svgr,
 * if modification needed please go to src/utils/icon-template.js
 */
const SVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}>
    <path
      fill="#00A0FF"
      d="M3.609 1.814 13.792 12 3.609 22.186a1.7 1.7 0 0 1-.495-1.2V3.014c0-.47.187-.896.495-1.2"
    />
    <path
      fill="#FFBC00"
      d="M17.14 15.348 13.792 12v-.001l3.349-3.348.075.043 3.97 2.256c1.134.645 1.134 1.696 0 2.34l-3.97 2.256-.076.043z"
    />
    <path
      fill="#FF3A44"
      d="M17.216 15.305 13.792 12 3.609 22.186c.374.396.992.445 1.688.05z"
    />
    <path
      fill="#00CF76"
      d="M17.216 8.695 5.297 1.764c-.696-.395-1.314-.346-1.688.05L13.792 12z"
    />
  </svg>
);
const SIZE = 24;
const CAN_SET_COLOR = false;
const SvgGooglePlayColor24 = styled(SVG)`
  min-height: ${SIZE}px;
  min-width: ${SIZE}px;
  max-height: ${SIZE}px;
  max-width: ${SIZE}px;
  cursor: ${(p) => (p.$pointer || p.onClick ? 'pointer' : 'default')};
  ${(p) =>
    CAN_SET_COLOR &&
    css`
      path {
        fill: ${themeGet(`colors.${p.color}`, p.color)};
      }
    `}
  ${space}
`;
export default SvgGooglePlayColor24;
